/* eslint-disable */
// prettier-ignore

import { createStore } from 'vuex'
import kwords from '@/database/db.js'

export default createStore({
  state: {
    pepper: [
      'пd',
      'б7',
      'пc',
      'цd',
      'ш7',
      'в7',
      'ю1',
      'лc',
      '∙',
      'u5',
      'о2',
      'и2',
      'w4',
      'є3',
      'и1',
      'є4',
      'w2',
      'и3',
      'и4',
      'и5',
      'ы2',
      'є1',
      'ю2',
      'ю4',
      'ю3',
      'v3'
    ],
    bottomInCurrent: [], // массив подстрочных слов со славяскими буквами в текущем кроссворде
    mainArr: [], // массив всех слов с позициями всех букв
    isOver: false,
    categories: [
      ['paskha', 'пасха'],
      ['troica', 'Троица'],
      ['pokrov', 'Покров'],
      ['vvedenie', 'Введение'],
      ['rozhd', 'Рождество'],
      ['alfabet', 'азбука'],
      ['sense', 'склонности'],
      ['animals', 'животные'],
      ['prying', 'Богослужение'],
      ['perfect', 'искус'],
      ['human', 'человек'],
      ['serafim', 'Cерафим']
    ],
    currCate: '',
    kwords,
    currentCross: null,
    isAuth: false
  },
  getters: {
    isAuth(state) {
      return state.isAuth
    },
    getMainArr(state) {
      return state.mainArr
    },
    getNumInCate(state) {
      return (cate) => {
        let j = 0
        for (let n of state.kwords) {
          if (n.cat === cate) {
            j++
          }
        }
        return j
      }
    },
    getCurrCate(state) {
      return state.currCate
    },
    getCrossFromCate(state) {
      return (category) => {
        // let q = ''
        let crossList = []
        for (let ite of state.categories) {
          if (ite[0] === category) {
            // q = it[1]
            state.currCate = ite[1]
            for (let cr of state.kwords) {
              if (cr.cat === ite[1]) {
                // было category до двумерного массива categories
                crossList.push(cr.id)
              }
            }
          }
        }
        // for (let cr of state.kwords) {
        //   if (cr.cat === q) {
        //     // было category до двумерного массива categories
        //     crossList.push(cr.id)
        //   }
        // }
        return crossList
      }
    },
    getOver(state) {
      return state.isOver
    },
    // массив генерируем из mainArr (можно удалить этот метод)
    getBottomInCurrentFromMainArr(state) {
      return (id) => {
        if (id > -1) {
          // push exist
          let mix = new Array()
          // console.log(state.mainArr[id])
          for (let letter of state.mainArr[id]) {
            if (letter.ft === 0) {
              mix.push(letter.s)
            } else mix.push('1') // '1' т.к. сдвиг идет при выбивании буквы
          }
          // дополняем
          if (mix.length < 18) {
            let d = 18 - mix.length
            for (let e = 0; e < d; e++) {
              mix.push('')
            }
          }
          return mix
        } else return new Array(18)
      }
    }
  },
  mutations: {
    SET_OVER(state) {
      state.isOver = false
    },
    SET_AUTH(state, payload) {
      state.isAuth = payload
    },
    SET_CURRENT_CROSS(state, { uidd, idx }) {
      // находим кроссворд по uidd и ставим ему jndex
      for (let cr of state.kwords) {
        if (cr.id === uidd) {
          state.currentCross = cr
          state.currentCross.jndex = idx
        }
      }
    },
    NULL_CURRENT_CROSS(state) {
      state.currentCross = {}
    },
    FT_UPTWO(state) {
      for (let slovo of state.mainArr) {
        for (let bykva of slovo) {
          if (bykva.ft === 1) {
            bykva.ft = 2
          }
        }
      }
    },
    FT_DOWNONE(state, twoIdClue) {
      for (let idClue of twoIdClue) {
        let replacable = state.mainArr[idClue]
        for (let l of replacable) {
          if (l.ft === 2) {
            l.ft = 1
          }
        }
      }
    },
    UPDATE_LETTER(state, { idxClue, letterIndex }) {
      let qq = 0
      let replacable = state.mainArr[idxClue][letterIndex] // объект с буквой и координатами
      let copy = Object.assign({}, replacable)
      for (let word of state.mainArr) {
        for (let letter of word) {
          if (JSON.stringify(letter) === JSON.stringify(copy)) {
            letter.ft = 1
          }
        }
      }

      // проверяем, остались ли буквы, содержащие нули?
      for (let sl of state.mainArr) {
        for (let by of sl) {
          if (by.ft === 0) {
            qq++
          }
        }
      }
      if (qq === 0) {
        state.isOver = true
      }
    },
    CREATE_MAINARR(state) {
      this.state.bottomInCurrent = [] // обновляем подстрочные славянские слова
      this.state.mainArr = [] // обновляем главный массив
      // let crossWord = state.kwords[crossNum]
      let crossWord = state.currentCross // теперь ориентируемся уже на готовый кроссворд
      crossWord.ws.forEach((word, idx) => {
        let larr = [] // для внесения лигатур
        let predLetters = [] // массив славянских букв в слове
        // собираем лигатуры в один массив
        for (let j = 0; j < state.pepper.length; j++) {
          let b = [...word.matchAll(state.pepper[j])]
          b.forEach((el) => {
            larr.push(el[0])
          })
        }
        // заменяем в слове лигатуры на *
        larr.forEach((l) => {
          word = word.replaceAll(l, '*')
        })
        // собираем массив славянских букв с нужными координатами
        for (let k = 0; k < word.length; k++) {
          predLetters.push([word.charAt(k), k])
        }
        // получаем предмассив с нужными координатами
        let m = 0
        let wordLetters = [] // массив славянских букв текущего слова для перемешивания внизу
        predLetters.map((pr) => {
          if (pr[0] === '*') {
            pr[0] = larr[m]
            m++
          }
          wordLetters.push(pr[0])
        })
        state.bottomInCurrent.push(wordLetters) // в массив слов со славянскими буквами
        let wordLettersPos = predLetters.reduce((acc, byk) => {
          let obj = {}
          if (crossWord.xy[idx].length === 3) {
            obj = {
              ft: 0,
              s: byk[0],
              xy: [crossWord.xy[idx][0], byk[1] + crossWord.xy[idx][1]]
            }
          } else {
            obj = {
              ft: 0,
              s: byk[0],
              xy: [byk[1] + crossWord.xy[idx][0], crossWord.xy[idx][1]]
            }
          }
          acc.push(obj)
          return acc
        }, [])
        state.mainArr.push(wordLettersPos)
      })
    }
  },
  actions: {},
  modules: {}
})
